/**
 * Probe / WIP Mascot v4 — noch nicht final Branding.
 * Asset: public/arko-mascot-v4-probe.png (Transparenz, dunkler Chat-Hintergrund).
 */
export const ARKO_MASCOT_PROBE_SRC = '/arko-mascot-v4-probe.png';

type ArkoMascotAvatarProps = {
  /** Tailwind size on the outer circle, e.g. w-6 h-6 */
  sizeClassName?: string;
  className?: string;
  title?: string;
};

/** Runder Assistenten-Avatar (Chat-Bubbles / Loading) — ersetzt Lucide Bot probeweise. */
export function ArkoMascotAvatar({
  sizeClassName = 'w-6 h-6',
  className = '',
  title = 'ARKO (Probe-Mascot v4)',
}: ArkoMascotAvatarProps) {
  return (
    <div
      className={`${sizeClassName} rounded-full overflow-hidden flex-shrink-0 bg-slate-900/40 border border-white/10 ${className}`}
      title={title}
      aria-hidden
    >
      <img
        src={ARKO_MASCOT_PROBE_SRC}
        alt=""
        className="w-full h-full object-cover object-center"
        draggable={false}
      />
    </div>
  );
}
